module.exports = {"asl.heading":"ASL"}


//////////////////
// WEBPACK FOOTER
// ./src/components/i18n/locales/fr.json
// module id = 705
// module chunks = 0